export enum CountriesType {
	CO = 'CO',
	BR = 'BR',
	MX = 'MX',
}
